import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { APP_DIALOG_DATA } from '../../shared/components/dialog/dialog.tokens';
import { AppDialogRef } from '../../shared/components/dialog/dialog-ref';
import { DIALOG_IMPORTS } from '../../shared/components/dialog/dialog.imports';

export interface UploadErrorDialogData {
  titleKey: string;
  messageKeys: string[];
  cancelKey: string;
  actionKey: string;
}

export type UploadErrorDialogResult = 'cancel' | 'reselect';

@Component({
  selector: 'app-upload-error-dialog',
  standalone: true,
  imports: [CommonModule, ...DIALOG_IMPORTS, MatButtonModule, TranslateModule],
  templateUrl: './upload-error-dialog.component.html'
})
export class UploadErrorDialogComponent {
  constructor(
    @Inject(APP_DIALOG_DATA) public data: UploadErrorDialogData,
    private dialogRef: AppDialogRef<UploadErrorDialogComponent, UploadErrorDialogResult>
  ) {}

  cancel(): void {
    this.dialogRef.close('cancel');
  }

  reselect(): void {
    this.dialogRef.close('reselect');
  }
}
